import { Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { openDialog } from '../../../base/dialog/actions';
import { IconRaiseHand } from '../../../base/icons/svg';
import { JitsiRecordingConstants } from '../../../base/lib-jitsi-meet';
import { getLocalParticipant } from '../../../base/participants/functions';
import Watermarks from '../../../base/react/components/web/Watermarks';
import { open as openParticipantsPane } from '../../../participants-pane/actions.web';
import LocalRecordingManager from '../../../recording/components/Recording/LocalRecordingManager.web';
import StopRecordingDialog from '../../../recording/components/Recording/web/StopRecordingDialog';
import RecordingLabel from '../../../recording/components/web/RecordingLabel';
import { canStopRecording, getActiveSession, getSessionStatusToShow, isRecordingRunning } from '../../../recording/functions';
import useTimer from './useTimer';
const useStyles = makeStyles()(theme => {
    return {
        recordingWrapper: {
            paddingTop: '2px',
            paddingBottom: '2px',
            '& #stop-share-screen': {
                paddingTop: '3.5px',
                paddingBottom: '3.5px',
            },
        },
        iconRecording: {
            fontSize: '13px',
            fontWeight: 500,
            '& svg': {
                width: '24px',
                height: '24px'
            }
        }
    };
});
const RoomInfo = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { classes, cx } = useStyles();
    // const _recordInfo = useSelector((state: IReduxState) => getRecordingInfo(state))
    const hasRecording = useSelector(isRecordingRunning);
    const _canStopRecording = useSelector(canStopRecording);
    // const _canRecording = useSelector((state: IReduxState) => isLocalParticipantCanRecording(state))
    const _local = useSelector(getLocalParticipant);
    const raisedHandsCount = useSelector((state) => (state['features/base/participants'].raisedHandsQueue || []).length);
    // const _conference = useSelector((state: IReduxState) => state['features/base/conference'].conference)
    const { _displaySubtitles, _language: _subtitlesLanguage } = useSelector((state) => state['features/subtitles']);
    const _fileRecordingSession = useSelector((state) => getActiveSession(state, JitsiRecordingConstants.mode.FILE));
    const _sessionStatus = useSelector((state) => getSessionStatusToShow(state, JitsiRecordingConstants.mode.FILE));
    const _localRecording = useSelector((state) => LocalRecordingManager.isRecordingLocally());
    const { headerEnabled } = useSelector((state) => state['features/toolbox']);
    const { timestampStartRecording } = useSelector((state) => state['features/recording']);
    const { timerValue } = useTimer({ startTimestamp: timestampStartRecording && timestampStartRecording * 1000 });
    const isLocalRecording = _localRecording || _fileRecordingSession?.initiator === _local?.id;
    // const _toggleScreenshotCapture = () => {
    //     dispatch(toggleScreenshotCaptureSummary(false));
    // }
    const handleOpenParticipantsPane = () => {
        dispatch(openParticipantsPane());
    };
    const handleStopRecord = () => {
        return dispatch(openDialog(StopRecordingDialog));
        // sendAnalytics(createRecordingDialogEvent('stop', 'confirm.button'));
        // const localRecordingVideoStop = LocalRecordingManager.selfRecording.withVideo
        // if (_localRecording) {
        //     dispatch(stopLocalVideoRecording());
        //     if (localRecordingVideoStop) {
        //         dispatch(setVideoMuted(true));
        //     }
        // } else if (_fileRecordingSession) {
        //     _conference?.stopRecording(_fileRecordingSession.id);
        //     _toggleScreenshotCapture();
        // }
        // // TODO: this should be an action in transcribing. -saghul
        // dispatch(setRequestingSubtitles(Boolean(_displaySubtitles), _displaySubtitles, _subtitlesLanguage));
        // _conference?.getMetadataHandler().setMetadata(RECORDING_METADATA_ID, {
        //     isTranscribingEnabled: false
        // });
        // return true;
    };
    // const isLocalRecording = LocalRecordingManager.isRecordingLocally()
    return (React.createElement("div", { className: 'record-rasie' },
        React.createElement(Watermarks, null),
        // _recordInfo && _recordInfo?.status === "on" &&
        headerEnabled && hasRecording && _sessionStatus === "on" &&
            React.createElement("div", { className: cx('info-share-screen', classes.recordingWrapper) },
                React.createElement("div", { className: `icon-share-record ${classes.iconRecording}` },
                    React.createElement(React.Fragment, null,
                        React.createElement(RecordingLabel, { className: 'record-info', mode: JitsiRecordingConstants.mode.FILE }),
                        React.createElement(RecordingLabel, { className: 'record-info', mode: JitsiRecordingConstants.mode.STREAM })),
                    t("conferenceInfo.record")),
                _canStopRecording && React.createElement(Button, { id: 'stop-share-screen', variant: 'outlined', size: 'small', sx: { color: 'white !important', border: '1px solid white !important', borderRadius: '6px' }, onClick: handleStopRecord }, t("conferenceInfo.stopRecord")),
                React.createElement("span", { id: 'time-share-screen' }, timerValue)),
        false &&
            React.createElement("div", { className: 'raise-count', onClick: handleOpenParticipantsPane },
                React.createElement(IconRaiseHand, null),
                React.createElement("span", null, raisedHandsCount))));
};
export default RoomInfo;
